import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";

const defaultFields = {
  avatars: ["name", "image", "ws", "is", "tokenPrice", "skinName"],
  skins: ["name", "avatarName", "image", "ws", "is", "tokenPrice"],
  stickers: ["name", "image", "tokenPrice"],
  emotes: ["name", "image", "tokenPrice"],
  screens: ["name", "image", "tokenPrice"],
};

const isImageField = (field) => ["image", "ws", "is"].includes(field);

const CreateItemModal = ({ open, onClose, collection, onCreate }) => {
  const [formData, setFormData] = useState({});

  const fields = defaultFields[collection] || [];

  useEffect(() => {
    const initial = {};
    fields.forEach((field) => (initial[field] = ""));
    setFormData(initial);
  }, [collection]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    const requiredFields = fields.filter(
      (f) => !["is", "skinName"].includes(f)
    );

    for (const field of requiredFields) {
      if (!formData[field]) {
        alert(`"${field}" is required.`);
        return;
      }
    }

    formData.tokenPrice = Number(formData.tokenPrice);
    onCreate(formData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{`Create New ${collection?.slice(0, -1)}`}</DialogTitle>
      <DialogContent>
        {fields.map((field) => (
          <Box key={field} mb={2}>
            <TextField
              label={field}
              fullWidth
              type={field === "tokenPrice" ? "number" : "text"}
              value={formData[field] || ""}
              onChange={(e) => handleChange(field, e.target.value)}
            />
            {isImageField(field) && formData[field] && (
              <Box mt={1}>
                <Typography variant="caption">Preview:</Typography>
                <Box
                  component="img"
                  src={formData[field]}
                  alt={`${field} preview`}
                  sx={{
                    width: field === "image" ? 80 : 48,
                    height: field === "image" ? 80 : 48,
                    objectFit: "contain",
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    mt: 0.5,
                  }}
                />
              </Box>
            )}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateItemModal;
